import { useDispatch, useSelector } from "react-redux";
import { fetchContacts } from "../../../state/actions/contacts";
import { useState } from "react";
import ContactsListFunctional from "./ContactsListFunctional";
import ContactsSearchFunctional from "../Contacts/ContactsSearchFunctional";

const ContactsListView = (props) => {
  const profileImages = useSelector((state) => state.profileImages);
  const {addContactMenu,setAddContactMenu,user, userId} = props;
  const dispatch = useDispatch();
  const selectedDomain = useSelector((state) => state.domain.selectedDomain);
  const selectContact= useSelector((state) => state.contacts.selectedContact);
  const allContacts = useSelector((state) => state.contacts.allContacts);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchText, setSearchText] = useState("");
 	const doSearch = (searchText) => {
		searchContacts(searchText, allContacts);
	};

	const searchContacts = (searchText, contactsData) => {
		if (!searchText || !searchText.length) {
			// If no search text, reset the contacts state to show all contacts
			// this.setState({
			// 	contacts: allContacts,
			// 	filteredContacts: [],
			// 	searchText: "",
			// });
      setFilteredContacts([]);
      setSearchText('');
			return; // Exit the function
		}
		let filteredContacts = [];
		let contactsArr = [];
		allContacts.map(x => contactsArr.push(...x.contacts));

		if (contactsArr?.length > 0) {
			let searchString = searchText?.toLowerCase();
			filteredContacts = contactsArr.filter((contact) => {
				let name = contact?.userName?.toLowerCase();
				let email = contact?.emailAddress?.toLowerCase();
				let homeMail = contact?.emailAddresses?.home?.toLowerCase();
				let workMail = contact?.emailAddresses?.work.toLowerCase();
				let arr = [-1, undefined];
			
				return (
					!arr.includes(name?.search(searchString)) ||
					!arr.includes(email?.search(searchString)) ||
					!arr.includes(homeMail?.indexOf(searchString)) ||
					!arr.includes(workMail?.indexOf(searchString))
				); 
			})
		}
    setFilteredContacts(filteredContacts);
    setSearchText(searchText);
	};
  return (
    <>
      
        <div className="">
          <div className="relative">
            <ContactsSearchFunctional
              parentComponent="home"
              search={doSearch}
            />
          </div>
          <div style={{ backgroundColor: "#F3F3FA" }}>
          <ContactsListFunctional
            selectedDomain={selectedDomain}
            addContactMenu={addContactMenu}
            setAddContactMenu={setAddContactMenu}
            dispatch={dispatch}
            // startChatWithContact={this.props.startChatWithContact}
            // startConversation={this.startConversation}
            user={user}
            userId={userId}
            allProfileImages={profileImages}
            filteredContacts={filteredContacts}
            fetchContacts={fetchContacts}
            // selectedId={selectedId}
            // showMenu={this.state.showMenu}
            // toggleMenu={this.toggleMenu}
            selectContact={selectContact}
            searchText={searchText || ''}
          // history={this.props.history}
          />
          </div>
        </div>
    </>
  );
};
export default ContactsListView;
